import { useMemo } from "react";
import routeList from "constants/routes";

const createPermissionMap = (permissionsArray) => {
  if (!Array.isArray(permissionsArray)) return {};
  return permissionsArray.reduce((acc, perm) => {
    if (perm.NomeInterno) {
      acc[perm.NomeInterno] = { name: perm.NomeMenu };
    }
    return acc;
  }, {});
};

const findFirstPermission = (permissionMap, keys) => {
  if (!keys) return undefined;
  const keysToCheck = Array.isArray(keys) ? keys : [keys];
  for (const key of keysToCheck) {
    if (permissionMap[key]) {
      return permissionMap[key];
    }
  }
  return undefined;
};

const generateRoutes = (config, sessionMap, viewMap, isVisionMode) => {
  return config.map((route) => {
    let sessionPermission =
      route.authRequired === false
        ? { name: route.defaultName }
        : findFirstPermission(sessionMap, route.permissionKey);

    if (isVisionMode && route.permissionKey === "AdminPortal") {
      sessionPermission = { name: route.defaultName };
    }

    let finalViews = route.views || [];
    let hasVisibleChildren = !route.collapse;

    if (route.collapse && Array.isArray(route.views)) {
      finalViews = route.views.map((view) => {
        let viewPermission =
          findFirstPermission(viewMap, view.permissionKey) ||
          (view.authRequired === false
            ? { name: view.defaultName }
            : undefined);

        if (isVisionMode && view.permissionKey === "TrocaUsuario") {
          viewPermission = { name: view.defaultName };
        }

        const isViewVisible = !!viewPermission || !!view.href;

        let finalName = view.defaultName;
        if (viewPermission && viewPermission.name) {
          finalName = viewPermission.name;
        }

        return {
          ...view,
          name: finalName,
          invisible: !isViewVisible,
        };
      });
      hasVisibleChildren = finalViews.some((v) => !v.invisible);
    }

    const isRouteVisible =
      !!sessionPermission && (!route.collapse || hasVisibleChildren);

    return {
      ...route,
      name: sessionPermission ? sessionPermission.name : route.defaultName,
      views: finalViews,
      invisible: route.invisible === true ? true : !isRouteVisible,
    };
  });
};

export const useRoutes = () => {
  const userVision = localStorage.getItem("userVision");

  const sessoesMenuUserRaw = localStorage.getItem("sessoesMenuUser");
  const viewsMenuUserRaw = localStorage.getItem("viewsMenuUser");
  const sessoesMenuUserVisionRaw = localStorage.getItem(
    "sessoesMenuUserVision"
  );
  const viewsMenuUserVisionRaw = localStorage.getItem("viewsMenuUserVision");

  const isVisionActive = useMemo(
    () => userVision && userVision !== "default",
    [userVision]
  );

  const permissionMaps = useMemo(() => {
    const isVisionActive = userVision && userVision !== "default";
    const sessoesRaw = isVisionActive
      ? sessoesMenuUserVisionRaw
      : sessoesMenuUserRaw;
    const viewsRaw = isVisionActive ? viewsMenuUserVisionRaw : viewsMenuUserRaw;

    try {
      const sessions = JSON.parse(sessoesRaw);
      const views = JSON.parse(viewsRaw);
      return {
        sessionMap: createPermissionMap(sessions),
        viewMap: createPermissionMap(views),
      };
    } catch (error) {
      console.error(
        "Failed to parse user permissions from localStorage",
        error
      );
      return { sessionMap: {}, viewMap: {} };
    }
  }, [
    userVision,
    sessoesMenuUserRaw,
    viewsMenuUserRaw,
    sessoesMenuUserVisionRaw,
    viewsMenuUserVisionRaw,
  ]);

  const routesVision = useMemo(
    () =>
      generateRoutes(
        routeList,
        permissionMaps.sessionMap,
        permissionMaps.viewMap,
        isVisionActive
      ),
    [permissionMaps, isVisionActive]
  );

  return {
    routesVision,
  };
};
